import React from "react";

import TextLink from "./TextLink";

import { getGlossaryUrl } from "utils/cryptopedia";

interface EntryLinkProps {
  children: any;
  target: any;
  cryptopedia?: boolean;
}

const EntryLink: React.FunctionComponent<EntryLinkProps> = ({
  children,
  target,
  ...props
}) => {
  // TODO need to handle for various entry link types; #na would identify
  const contentType = target?.sys?.contentType?.sys?.id;
  let url = "#na";
  switch (contentType) {
    case "cryptopediaGlossary": {
      url = getGlossaryUrl(target.fields.name);
      break;
    }
  }
  return (
    <TextLink href={url} {...props}>
      {children}
    </TextLink>
  );
};

export default EntryLink;
